export function createWorkingHoursDescription(
  workingHours?: {
    dayOfTheWeek: string;
    startTime: string;
    endTime: string;
  }[],
) {
  // create a map by day of the week
  const dayMap: Record<string, { startTime: string; endTime: string }[]> = {};
  workingHours?.forEach((item) => {
    if (!dayMap[item.dayOfTheWeek]) {
      dayMap[item.dayOfTheWeek] = [];
    }
    dayMap[item.dayOfTheWeek].push({
      startTime: item.startTime,
      endTime: item.endTime,
    });
  });

  // create a description for each day
  const daysDescriptions = Object.keys(dayMap)?.map((dayOfTheWeek) => {
    const day = dayMap[dayOfTheWeek];
    const times = day
      .map((item) => formatTimes(item.startTime, item.endTime))
      .join(" + ");
    return `${dayOfTheWeek.slice(0, 3)}: ${times}`;
  });

  return daysDescriptions?.join(", ");
}

function formatTimes(start: string, end: string) {
  const startTime = formatTime(start.split(" ")[0]);
  const startUnit = start.split(" ")[1].toLowerCase();
  const endTime = formatTime(end.split(" ")[0]);
  const endUnit = end.split(" ")[1].toLowerCase();
  if (startUnit === endUnit) {
    return `${startTime}-${endTime}${endUnit}`;
  }
  return `${startTime}${startUnit}-${endTime}${endUnit}`;
}

function formatTime(time: string) {
  let [hours, minutes] = time.split(":");
  if (hours.startsWith("0")) {
    hours = hours.slice(1);
  }
  if (minutes === "00") {
    minutes = "";
  }
  return `${hours}${minutes ? `:${minutes}` : ""}`;
}
